import { GlobalPriceTableHeaderProps } from './GlobalPriceTableHeader.types';

export function GlobalPriceTableHeader({ fuelTypes, headerRef }: GlobalPriceTableHeaderProps): JSX.Element {
  return (
    <div className="price-processing-global-header-wrapper" ref={headerRef}>
      <div className="price-processing-table">
        <div className="price-processing-table-header">
          <div className="price-processing-header-cell price-processing-region-col">Регіон</div>
          <div className="price-processing-header-cell price-processing-province-col">Область</div>
          <div className="price-processing-header-cell price-processing-brand-col">Бренд</div>
          <div className="price-processing-header-cell price-processing-last-date-col">Остання дата зміни цін</div>
          {fuelTypes.map(fuel => (
            <div key={fuel} className="price-processing-header-cell price-processing-fuel-col">
              {fuel}
            </div>
          ))}
          <div className="price-processing-header-cell price-processing-date-col">Дата зміни цін</div>
        </div>
      </div>
    </div>
  );
}
